export default __webpack_public_path__ + "static/divertidamentes-10b49d89059e9edfd7a72898903ee0f9.png";